import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Hur ser kunskapsprovets frågedatabas ut?";
const SHORT_ANSWER = "Folkhälsomyndigheten har en stor databas med slumpade frågor inom varje område. Frågorna roteras så att två personer aldrig får exakt samma prov.";

export const Route = createFileRoute("/fraga/hur-bra-ar-folkhalsomyndighetens-databas")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Hur ser kunskapsprovets frågedatabas ut" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Detta gör det omöjligt att 'memorera' enstaka frågor. Effektivare är att förstå reglerna och träna på övningsfrågor som speglar samma områden. Alkoholprovet replikerar formatet."}
      source={{ label: "FoHMFS 2014:7 – Föreskrifter om kunskapsprov", href: "https://www.folkhalsomyndigheten.se/publikationer-och-material/publikationsarkiv/f/fohmfs-20147/" }}
      extraSources={[]}
      deepGuide={{ to: "/practice", label: "Träna på samma format" }}
      related={[{"to": "/fraga/far-jag-rast-under-provet", "label": "Får jag ta rast under kunskapsprovet?"}, {"to": "/fraga/hur-rattas-provet", "label": "Hur rättas kunskapsprovet?"}, {"to": "/fraga/behover-jag-gora-om-provet-vid-utokning", "label": "Behöver jag göra om provet om jag utökar tillståndet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Hur ser kunskapsprovets frågedatabas ut?" },
      { name: "description", content: "Folkhälsomyndigheten har en stor databas med slumpade frågor inom varje område. Frågorna roteras så att två personer aldrig får exakt samma prov." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/hur-bra-ar-folkhalsomyndighetens-databas" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/hur-bra-ar-folkhalsomyndighetens-databas" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/hur-bra-ar-folkhalsomyndighetens-databas",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Hur ser kunskapsprovets frågedatabas ut", url: "https://alkoholprovet.se/fraga/hur-bra-ar-folkhalsomyndighetens-databas" },
      ]),
    ],
  }),
});
